<template>
    <div class="login">
        <div class="container">
            <div class="row">
                <div class="col-md-2"></div>
                <div class="col-md-8" align-v="center">
                    <div class="card">
                        <div class="card-head">
                            <div class="row">
                                <div class="col-md-6 col-12 primes text-center">
                                     <div style="margin-top:60%" >
                                    <div >
                                       <h4 class="text-white"> <b>Shipserv Ltd Triq Patri Tedeo Schembri ZABBAR ZBR2691 MALTA</b> </h4> 
                                    </div>
                                    <div>
                                      <h5 class="text-white">Tax Number: MT 2184 7134</h5> 
                                    </div>
                                    </div>
                                    <!-- <img src="../assets/img/oneshot.png" width="100%" class="logo" alt=""> -->
                                </div>
                                <div class="col-md-6 col-12 text-center px-5">
                                    <h2 class="heading">Password Reset</h2>
                                    <form class="mt-3">
                                        <input type="email" v-model="email"  placeholder="Enter your email" class="form-control">
                                        <!-- <button class="form-control btn btn-primary mt-3" @click="login">Confirm</button> -->
                                        <b-button @click="resestPass" variant="primary" block >Reset Password</b-button>
                                        <div><sub>We will send you a link to your email account</sub></div>
                                        <div><sub>Have an account login <router-link to="/">Login Here</router-link> </sub></div>
                                        
                                        
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "Login",
    data(){
        return {
            email:''
        }
    },
    methods: {
        resestPass() {
            // this.$router.push({path: '/dashboard'})
            this.$store.dispatch("passwordReset",this.email)
        }
    }
}
</script>

<style scoped>
.login {
        /* background: #d7dfe1; */
        min-height: 100vh;
        padding-top: 40px;
    }
    .primes {
        background: #5580fe;
        height: 710px !important;
    }
    .logo {
        margin-top: 70%;
    }
    
    p {
        font-size: 14px;
        margin-top: 10px;
    }
    .log:hover {
        cursor: pointer;
    }
    h2 {
        margin-top: 70%;
    }
    @media screen and (max-width: 567px) {
        .login {
            padding-top: 0px;
        }
        h2 {
            margin-top: 10%;
        }
    }
</style>